<template>
    <div class="modal is-active">
        <div class="modal-background"/>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t('portals.edit.title') }}
                </p>
                <button class="delete" @click="close"/>
            </header>
            <section class="modal-card-body">
                <div class="edit-portal d-flex">
                    <div class="columns edit-portal__content">
                        <div class="column is-6-mobile is-half">
                            <img
                                v-if="portal.logo_big"
                                class="edit-portal__logo" :src="portal.logo_big"
                                :alt="`${portal.name} Logo`"
                            >
                            <img
                                v-else-if="portal.logo"
                                class="edit-portal__logo" :src="portal.logo"
                                :alt="`${portal.name} Logo`"
                            >
                            <i v-else class="fa fa-picture-o edit-portal__logo" aria-hidden="true"/>
                        </div>
                        <div class="d-flex column is-6-mobile is-half flex-column">
                            <p class="mb-4">{{ portal.name }}</p>
                            <a :href="`${portal.website}`" v-if="portal.website" target="_blank">
                                <i aria-hidden="true" class="fa fa-globe fa-fw"/>
                                {{ $t('portals.edit.website') }}
                            </a>
                            <a :href="`${portal.documentation_url}`" v-if="portal.documentation_url" target="_blank">
                                <i aria-hidden="true" class="fa fa-book fa-fw"/>
                                {{ $t('portals.edit.documentation') }}
                            </a>
                            <p class="edit-portal__active-state">
                                <template v-if="portal['campground_info'].active">
                                    <i
                                        aria-hidden="true"
                                        class="fa fa-check-circle fa-fw is-valid"
                                    />
                                    {{ $t('portals.edit.active') }}
                                </template>
                                <template v-else>
                                    <i
                                        aria-hidden="true"
                                        class="fa fa-minus-circle fa-fw is-invalid"
                                    />
                                    {{ $t('portals.edit.inactive') }}
                                </template>
                            </p>
                        </div>

                        <div class="column is-8-mobile is-8-desktop">
                            <label class="d-inline-block tooltip-activator">
                                {{ $t('portals.edit.commission') }}
                                <span class="tooltip tooltip--is-large tooltip--is-right">{{ $t('portals.edit.commissionHint') }}</span>
                            </label>
                        </div>
                        <div class="column is-4-mobile is-4-desktop">
                            <input
                                class="is-countbig"
                                type="number"
                                step="0.01"
                                placeholder="0.00"
                                v-model="portal.campground_info.commission"
                            >
                        </div>

                        <div class="column is-8-mobile is-8-desktop">
                            <label class="d-inline-block tooltip-activator pointer" for="commission">
                                {{ $t('portals.edit.cncCommission') }}
                                <span class="tooltip tooltip--is-large tooltip--is-right">{{ $t('portals.edit.cncCommissionHint') }}</span>
                            </label>
                        </div>
                        <div class="column is-4-mobile is-4-desktop">
                            <input class="w-100 pointer"
                                   v-model="portal['campground_info'].include_changer_commission"
                                   type="checkbox"
                                   name="commission"
                                   id="commission"
                            >
                        </div>

                        <div class="column is-8-mobile is-8-desktop" v-if="portal.cnc_booking_funnel">
                            <label class="d-inline-block tooltip-activator pointer" for="cnc_booking_funnel_active">
                                {{ $t('portals.edit.cncBookingFunnelActive') }}
                            </label>
                        </div>
                        <div class="column is-4-mobile is-4-desktop" v-if="portal.cnc_booking_funnel">
                            <input class="w-100 pointer"
                                   v-model="portal.campground_info.active"
                                   type="checkbox"
                                   name="cnc_booking_funnel_active"
                                   id="cnc_booking_funnel_active"
                            >
                        </div>



                    </div>
                    <div class="columns edit-portal__content">
                        <div class="column is-12">
                            <h3>Beschreibung</h3>
                            <p v-html="portal.description"/>
                        </div>
                        <div class="column is-12" v-if="!documentsAccepted">
                            <h3>Dokumente</h3>
                            <p>Sie haben noch nicht alle nötigen Dokumente akzeptiert.</p>
                        </div>
                        <div class="column is-12">
                            <AddAccommodation
                                :portal="portalProp"
                                :campsites="campsites"
                                @update-portal="update"
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <PortalMembersTable
                        :campsites="campsites"
                        :portal="portal"
                        :portal-members="portalMembers"
                        @update-portal="update"
                    />
                </div>
            </section>
            <footer class="modal-card-foot">
                <div class="block ml-auto">
                    <button class="button is-link" @click.prevent="close">
                        {{ $t('generic.cancel') }}
                    </button>
                    <button
                        class="button is-primary"
                        @click.prevent="save"
                    >
                        {{ $t('generic.save') }}
                    </button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import Api from '../../../api/Api';
import PortalMembersTable from './portalMembersTable.vue';
import AddAccommodation from './addAccommodation.vue';

export default {
    name: 'editPortal',
    components: { AddAccommodation, PortalMembersTable },
    props: {
        campsites: Array,
        portalProp: Object,
        portalMembers: Array,
        documentsAccepted: Boolean,
    },
    data() {
        return {
            portal: null,
        };
    },
    created() {
        this.portal = cloneDeep(this.portalProp);
        console.log(this.portal);
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async save() {
            const data = {
                id: null,
                portal_id: this.portal.id,
                commission: this.portal.campground_info.commission,
                include_changer_commission: this.portal.campground_info.include_changer_commission,
                cnc_booking_funnel_active: this.portal.campground_info.active,
            };

            try {
                await Api.portals.update(data);
                this.update();
                this.close();
            } catch (e) {
                console.log(e);
            }
        },
        update() {
            this.$emit('update');
        },
    },
};
</script>

<style lang="scss" scoped>
.edit-portal {
    flex-wrap: wrap;

    &__content {
        margin: 0;
        flex-basis: 50%;
        flex-wrap: wrap;
    }

    &__logo {
        width: 15rem;
        font-size: 10rem;
    }

    &__active-state {
        margin-top: 1rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/components/portals/editPortal.vue